import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    minWidth: 430,
    height: '',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    backgroundColor: Colors.white,
    padding: '1.5rem',
    borderRadius: 5,
    '@media (max-width: 500px)': {
      minWidth: 'calc(100vw - 5rem)',
    },
  },

  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '2rem',
    padding: '0 0 1rem 0 ',
  },

  status: {
    padding: '0.5rem 1rem',
    textTransform: 'uppercase',
    color: Colors.white,
    fontSize: 11,
    backgroundColor: Colors.green,
    borderRadius: '3px',
    fontWeight: 'bold',
  },

  infoContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '1.5rem',
    width: '100%',
    padding: '1rem',
    border: `1px solid ${Colors.lightGray}`,
    borderRadius: 5,
    '@media (max-width: 600px)': {
      fontSize: '1.2rem',
      gap: '0.5rem',
    },
  },

  progress: {
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '1rem',
    '@media (max-width: 600px)': {
      padding: '0.5rem',
    },
  },

  dates: {
    padding: '1.5rem',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '1.5rem',
    flexDirection: 'column',
    '& > p > span': {
      fontWeight: 600,
    },
    '@media (max-width: 600px)': {
      padding: '0.5rem',
    },
  },

  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    paddingTop: '1rem',
  },
}))

export default styles
